import { render, staticRenderFns } from "./gender-comp.vue?vue&type=template&id=16ea4d4f&scoped=true&"
import script from "./gender-comp.vue?vue&type=script&lang=js&"
export * from "./gender-comp.vue?vue&type=script&lang=js&"
import style0 from "./gender-comp.vue?vue&type=style&index=0&id=16ea4d4f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ea4d4f",
  null
  
)

export default component.exports